import { render } from "./PhotoGrid.vue?vue&type=template&id=5ff95b70&scoped=true"
import script from "./PhotoGrid.vue?vue&type=script&lang=js"
export * from "./PhotoGrid.vue?vue&type=script&lang=js"

import "./PhotoGrid.vue?vue&type=style&index=0&id=5ff95b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff95b70"]])

export default __exports__